/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface IUnauthorizedResponse {
  /** @example 401 */
  statusCode: number
  /** @example "Unauthorized" */
  error: string
}

export interface IForbiddenResponse {
  /** @example 403 */
  statusCode: number
  /** @example "Forbidden" */
  error: string
}

export interface IAmbassadorMonthlyReportXlsxExportRequest {
  /**
   * @min 1
   * @max 12
   * @example 6
   */
  month: number
  /**
   * @min 2000
   * @max 2100
   * @example 2026
   */
  year: number
}

export interface IAmbassadorGlobalMonthlyReportXlsxExportOkResponse {
  /** Optional success message */
  message?: string
  /** @format base64 */
  data: string
}

export interface IBadRequestResponse {
  /** @example 400 */
  statusCode: number
  /** @example "Bad Request" */
  error: string
}

export interface IAmbassadorMonthlyReportXlsxExportOkResponse {
  /** Optional success message */
  message?: string
  /** @format base64 */
  data: string
}

export interface IAmbassadorSetIsEnabledRequest {
  isEnabled: boolean
}

export interface IAmbassadorSetIsEnabledOkResponse {
  /** Optional success message */
  message?: string
}

export interface IAmbassadorSums {
  clientCount: number
  investedSum: number
}

export interface IActivityDay {
  /** @format date-time */
  date: string
  investmentAmountSum: number
}

export interface IAmbassadorClient {
  name: string
  email: string
  investedSum: number
  /** @format date-time */
  createdAt: string
}

export interface IAmbassadorDetailData {
  _id: string
  /** @format date-time */
  createdAt: string
  createdBy: string
  /** @format date-time */
  modifiedAt: string
  modifiedBy: string
  userId: string
  reference: string
  code: string
  phone?: string
  isEnabled: boolean
  sums: IAmbassadorSums
  activityDays: IActivityDay[]
  clients: IAmbassadorClient[]
}

export interface IAmbassadorDetailOkResponse {
  /** Optional success message */
  message?: string
  data: IAmbassadorDetailData
}

export interface IAmbassadorSchema {
  _id: string
  /** @format date-time */
  createdAt: string
  createdBy: string
  /** @format date-time */
  modifiedAt: string
  modifiedBy: string
  userId: string
  reference: string
  code: string
  phone?: string
  isEnabled: boolean
  sums: IAmbassadorSums
  activityDays: IActivityDay[]
}

export interface IAccountAmbassadorData {
  sums: IAmbassadorSums
  ambassadors: IAmbassadorSchema[]
}

export interface IAmbassadorDataOkResponse {
  /** Optional success message */
  message?: string
  data: IAccountAmbassadorData
}

export interface IAmbassadorCodeCheckRequest {
  code: string
}

export interface IAmbassadorCodeCheckOkResponse {
  /** Optional success message */
  message?: string
}

export interface IAmbassadorReportChangeRequest {
  text: string
}

export interface IAmbassadorReportChangeOkResponse {
  /** Optional success message */
  message?: string
}

export interface IAmbassadorCreateDto {
  reference: string
  phone?: string
  code: string
}

export interface IAmbassadorCreateOkResponse {
  /** Optional success message */
  message?: string
  ambassador: IAmbassadorSchema
}

export interface IMyAmbassadorClaimRequest {
  ambassadorCode: string
}

export interface IMyAmbassadorClaimOkResponse {
  /** Optional success message */
  message?: string
}

export interface IAmbassadorData {
  reference: string
  code: string
  phone?: string
  isEnabled: boolean
}

export interface IMyAmbassadorData {
  ambassador: IAmbassadorData
  /** @format date-time */
  claimedAt: string
}

export interface IMyAmbassadorOkResponse {
  /** Optional success message */
  message?: string
  data: IMyAmbassadorData
}

export interface INotFoundResponse {
  /** @example 404 */
  statusCode: number
  /** @example "Not Found" */
  error: string
}

export interface IPublicAmbassadorInfoData {
  reference: string
  code: string
}

export interface IPublicAmbassadorInfoOkResponse {
  /** Optional success message */
  message?: string
  data: IPublicAmbassadorInfoData
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData())
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const responseToParse = responseFormat ? response.clone() : response
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title IIS Ambassador API
 * @version 1.0
 * @contact
 *
 * API for Ambassador
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  user = {
    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerGlobalMonthlyReportXlsxExport
     * @summary Export global ambassador monthly report XLSX
     * @request POST:/user/ambassador/global-monthly-report-xlsx-export
     * @secure
     */
    ambassadorControllerGlobalMonthlyReportXlsxExport: (
      data: IAmbassadorMonthlyReportXlsxExportRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IAmbassadorGlobalMonthlyReportXlsxExportOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador/global-monthly-report-xlsx-export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerMonthlyReportXlsxExport
     * @summary Export ambassador monthly report XLSX
     * @request POST:/user/ambassador/{ambassadorId}/monthly-report-xlsx-export
     * @secure
     */
    ambassadorControllerMonthlyReportXlsxExport: (
      ambassadorId: string,
      data: IAmbassadorMonthlyReportXlsxExportRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IAmbassadorMonthlyReportXlsxExportOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador/${ambassadorId}/monthly-report-xlsx-export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerAmbassadorSetIsEnabled
     * @summary Set ambassador isEnabled flag
     * @request PATCH:/user/ambassador/{ambassadorId}/set-is-enabled
     * @secure
     */
    ambassadorControllerAmbassadorSetIsEnabled: (
      ambassadorId: string,
      data: IAmbassadorSetIsEnabledRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IAmbassadorSetIsEnabledOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador/${ambassadorId}/set-is-enabled`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerGetAmbassadorDetail
     * @summary Get ambassador detail
     * @request GET:/user/ambassador/{ambassadorId}/detail
     * @secure
     */
    ambassadorControllerGetAmbassadorDetail: (
      ambassadorId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        IAmbassadorDetailOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador/${ambassadorId}/detail`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerGetAmbassadorData
     * @summary Get ambassador data of the logged user
     * @request GET:/user/ambassador/data
     * @secure
     */
    ambassadorControllerGetAmbassadorData: (params: RequestParams = {}) =>
      this.request<
        IAmbassadorDataOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador/data`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerPostAmbassadorCodeCheck
     * @summary Check ambassador code availability
     * @request POST:/user/ambassador/code-check
     * @secure
     */
    ambassadorControllerPostAmbassadorCodeCheck: (
      data: IAmbassadorCodeCheckRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IAmbassadorCodeCheckOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador/code-check`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerPostAmbassadorReportChange
     * @summary Report an ambassador change request
     * @request POST:/user/ambassador/report-change
     * @secure
     */
    ambassadorControllerPostAmbassadorReportChange: (
      data: IAmbassadorReportChangeRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IAmbassadorReportChangeOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador/report-change`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ambassador
     * @name AmbassadorControllerPostAmbassadorCreate
     * @summary Create an ambassador
     * @request POST:/user/ambassador
     * @secure
     */
    ambassadorControllerPostAmbassadorCreate: (
      data: IAmbassadorCreateDto,
      params: RequestParams = {}
    ) =>
      this.request<
        IAmbassadorCreateOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/ambassador`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MyAmbassador
     * @name MyAmbassadorControllerClaimMyAmbassador
     * @summary Claim my ambassador by code
     * @request POST:/user/my-ambassador/claim
     * @secure
     */
    myAmbassadorControllerClaimMyAmbassador: (
      data: IMyAmbassadorClaimRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IMyAmbassadorClaimOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/my-ambassador/claim`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MyAmbassador
     * @name MyAmbassadorControllerGetMyAmbassador
     * @summary Get my ambassador
     * @request GET:/user/my-ambassador
     * @secure
     */
    myAmbassadorControllerGetMyAmbassador: (params: RequestParams = {}) =>
      this.request<
        IMyAmbassadorOkResponse,
        IUnauthorizedResponse | IForbiddenResponse | INotFoundResponse
      >({
        path: `/user/my-ambassador`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  ambassador = {
    /**
     * No description
     *
     * @tags PublicAmbassador
     * @name PublicAmbassadorControllerGetAmbassadorByCode
     * @summary Get public ambassador info by code
     * @request GET:/ambassador/{ambassadorCode}/info
     */
    publicAmbassadorControllerGetAmbassadorByCode: (
      ambassadorCode: string,
      params: RequestParams = {}
    ) =>
      this.request<IPublicAmbassadorInfoOkResponse, INotFoundResponse>({
        path: `/ambassador/${ambassadorCode}/info`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
}
